import { typeOption } from '../constants/parameterTypes';
import { paramMode } from '../constants/parameterNames';
import { VALIDATION_MODE_AFTER_CHANGE, VALIDATION_MODE_AFTER_ERROR_CHANGE, VALIDATION_MODE_AUTO, VALIDATION_MODE_NONE } from "../../validation";
import { getParamValue } from '../helpers/parameter.accessors';

const description = "Sets the form's validation behavior, determining how frequently validation takes place.";

const requiredParameters = {
    [paramMode]: {
        description:
            `The validation mode to use. Possible values are: ${VALIDATION_MODE_NONE} - don't automatically validate; ${VALIDATION_MODE_AUTO} - validate before each view update (essentially after each user interaction); ${VALIDATION_MODE_AFTER_CHANGE} - after a field in the view is modified; ${VALIDATION_MODE_AFTER_ERROR_CHANGE} - after a field in the view with a validation error is modified. Default mode is ${VALIDATION_MODE_AFTER_ERROR_CHANGE}`,
        type: typeOption,
        options: [
            { name: 'None', value: VALIDATION_MODE_NONE },
            { name: 'Auto', value: VALIDATION_MODE_AUTO },
            { name: 'After field change', value: VALIDATION_MODE_AFTER_CHANGE },
            { name: 'After error field change', value: VALIDATION_MODE_AFTER_ERROR_CHANGE },
        ],
    },
};

const execute = ({ parameters, validation }) => {
    // setMode()  validates the value, so it is not necessary to validate it here
    validation.setMode(getParamValue(parameters, paramMode));

    return '';
};

const SetValidationMode = {
    description,
    requiredParameters,
    execute,
};

export default SetValidationMode;